export const SERVING_QTY_NUMBER_REGEX = /^(?=.*\d)\d*\.?\d{0,2}$/;

export const parseCompositeNumberAndUnit = (
  raw?: unknown
): { value: string; unit: string } => {
  const s = String(raw ?? "").trim();
  if (!s) return { value: "", unit: "" };

  const parts = s.split(/\s+/).filter(Boolean);
  const value = parts[0] ?? "";
  const unit = parts.slice(1).join(" ");
  return { value, unit };
};

export const isCompositeNumberAndUnitValid = (raw?: unknown): boolean => {
  const { value, unit } = parseCompositeNumberAndUnit(raw);
  return (
    SERVING_QTY_NUMBER_REGEX.test(String(value ?? "").trim()) &&
    String(unit ?? "").trim().length > 0
  );
};

